import {combine} from 'effector';

import {clearDocumentsGridCache, fetchDocumentsGrid, loadGridCsv} from 'api';
import {fetchInvoicesFilterState} from 'api/documents/documents';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {DocumentsGridRawRow} from 'types';
import {SimplePaginationContent} from 'types/api';

import {InvoiceFiltersState} from 'types/invoices';

const domain = rootDomain.createDomain('DocumentsGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDocumentListFx',
    handler: fetchDocumentsGrid,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearDocumentsGridCache,
});

export const fetchCsv = domain.createEffect({
    name: 'fetchDocumentsCsv',
    handler: loadGridCsv,
});

export const fetchDataFiltersFx = domain.createEffect({
    name: 'fetchDataFiltersFx',
    handler: fetchInvoicesFilterState,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<SimplePaginationContent<DocumentsGridRawRow> | null>(null);

export const searchChanged = domain.createEvent<string>();
export const searchReset = domain.createEvent();
export const search$ = domain
    .createStore<string>('')
    .on(searchChanged, (_, value) => value)
    .reset(searchReset);

export const updOnlyChanged = domain.createEvent<boolean>();
export const updOnly$ = domain.createStore<boolean>(false).on(updOnlyChanged, (_, value) => value);

export const refetchWithSortByDescDate = domain.createEvent();

export const gridCacheChanged = domain.createEvent<{pageNumber: number; token: string | null}>();
export const gridCacheReset = domain.createEvent();
export const gridTokensCache$ = domain.createStore<Record<number, string | null>>({0: null});

export const $invoicesFilters = domain.createStore<InvoiceFiltersState>({} as InvoiceFiltersState);

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    updOnly: updOnly$,
    gridTokensCache: gridTokensCache$,
    isLoading: fetchDataFx.pending,
    exportPending: fetchCsv.pending,
});
